export default "__VITE_ASSET__e70082bd__"